import { render } from "./InspectionError.vue?vue&type=template&id=55be47af&scoped=true"
import script from "./InspectionError.vue?vue&type=script&lang=ts"
export * from "./InspectionError.vue?vue&type=script&lang=ts"

import "./InspectionError.vue?vue&type=style&index=0&id=55be47af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55be47af"

export default script